import Vue from 'vue';

// Work Icons
import WorkIconAccessConfig from '@/components/global_components/work_icons/WorkIconAccessConfig';
import WorkIconAdd from '@/components/global_components/work_icons/WorkIconAdd';
import WorkIconApplicationReject from '@/components/global_components/work_icons/WorkIconApplicationReject';
import WorkIconApplicationReopen from '@/components/global_components/work_icons/WorkIconApplicationReopen';
import WorkIconArchived from '@/components/global_components/work_icons/WorkIconArchived';
import WorkIconArrowDown from '@/components/global_components/work_icons/WorkIconArrowDown';
import WorkIconAttention from '@/components/global_components/work_icons/WorkIconAttention';
import WorkIconBack from '@/components/global_components/work_icons/WorkIconBack';
import WorkIconBusinessTrip from '@/components/global_components/work_icons/WorkIconBusinessTrip';
import WorkIconCalculation from '@/components/global_components/work_icons/WorkIconCalculation';
import WorkIconCalendar from '@/components/global_components/work_icons/WorkIconCalendar';
import WorkIconCall from '@/components/global_components/work_icons/WorkIconCall';
import WorkIconCamera from '@/components/global_components/work_icons/WorkIconCamera';
import WorkIconCar from '@/components/global_components/work_icons/WorkIconCar';
import WorkIconCheck from '@/components/global_components/work_icons/WorkIconCheck';
import WorkIconCheckmark from '@/components/global_components/work_icons/WorkIconCheckmark';
import WorkIconCheckboxSelectAll from '@/components/global_components/work_icons/WorkIconCheckboxSelectAll';
import WorkIconCheckboxSelect from '@/components/global_components/work_icons/WorkIconCheckboxSelect';
import WorkIconCheckboxUnselect from '@/components/global_components/work_icons/WorkIconCheckboxUnselect';
import WorkIconCircle from '@/components/global_components/work_icons/WorkIconCircle';
import WorkIconClose from '@/components/global_components/work_icons/WorkIconClose';
import WorkIconCollapse from '@/components/global_components/work_icons/WorkIconCollapse';
import WorkIconColorNoSelection from '@/components/global_components/work_icons/WorkIconColorNoSelection';
import WorkIconColorSelection from '@/components/global_components/work_icons/WorkIconColorSelection';
import WorkIconConfirmDeviation from '@/components/global_components/work_icons/WorkIconConfirmDeviation';
import WorkIconContainer from '@/components/global_components/work_icons/WorkIconContainer';
import WorkIconCompany from '@/components/global_components/work_icons/WorkIconCompany';
import WorkIconCompanyAdd from '@/components/global_components/work_icons/WorkIconCompanyAdd';
import WorkIconCopyProject from '@/components/global_components/work_icons/WorkIconCopyProject';
import WorkIconCopyContact from '@/components/global_components/work_icons/WorkIconCopyContact';
import WorkIconCreateBill from '@/components/global_components/work_icons/WorkIconCreateBill';
import WorkIconCustomer from '@/components/global_components/work_icons/WorkIconCustomer';
import WorkIconDashboard from '@/components/global_components/work_icons/WorkIconDashboard';
import WorkIconDelete from '@/components/global_components/work_icons/WorkIconDelete';
import WorkIconDemand from '@/components/global_components/work_icons/WorkIconDemand';
import WorkIconDeputy from '@/components/global_components/work_icons/WorkIconDeputy';
import WorkIconDocument from '@/components/global_components/work_icons/WorkIconDocument';
import WorkIconDocumentAdd from '@/components/global_components/work_icons/WorkIconDocumentAdd';
import WorkIconDocumentPlus from '@/components/global_components/work_icons/WorkIconDocumentPlus';
import WorkIconDown from '@/components/global_components/work_icons/WorkIconDown';
import WorkIconDownload from '@/components/global_components/work_icons/WorkIconDownload';
import WorkIconDownloadCsv from '@/components/global_components/work_icons/WorkIconDownloadCsv';
import WorkIconDownloadExcel from '@/components/global_components/work_icons/WorkIconDownloadExcel';
import WorkIconDownloadZip from '@/components/global_components/work_icons/WorkIconDownloadZip';
import WorkIconEdit from '@/components/global_components/work_icons/WorkIconEdit';
import WorkIconEditModeOff from '@/components/global_components/work_icons/WorkIconEditModeOff';
import WorkIconEditModeOffAlt from '@/components/global_components/work_icons/WorkIconEditModeOffAlt';
import WorkIconEditModeOn from '@/components/global_components/work_icons/WorkIconEditModeOn';
import WorkIconEditView from '@/components/global_components/work_icons/WorkIconEditView';
import WorkIconElectricMagnifier from '@/components/global_components/work_icons/WorkIconElectricMagnifier';
import WorkIconEmail from '@/components/global_components/work_icons/WorkIconEmail';
import WorkIconEquals from '@/components/global_components/work_icons/WorkIconEquals';
import WorkIconExport from '@/components/global_components/work_icons/WorkIconExport';
import WorkIconExportMessage from '@/components/global_components/work_icons/WorkIconExportMessage';
import WorkIconFavorite from '@/components/global_components/work_icons/WorkIconFavorite';
import WorkIconFavoriteFilled from '@/components/global_components/work_icons/WorkIconFavoriteFilled';
import WorkIconFilter from '@/components/global_components/work_icons/WorkIconFilter';
import WorkIconFilterAdd from '@/components/global_components/work_icons/WorkIconFilterAdd';
import WorkIconFilterSelect from '@/components/global_components/work_icons/WorkIconFilterSelect';
import WorkIconGlobalSearch from '@/components/global_components/work_icons/WorkIconGlobalSearch';
import WorkIconGreaterThan from '@/components/global_components/work_icons/WorkIconGreaterThan';
import WorkIconHamburgerMenu from '@/components/global_components/work_icons/WorkIconHamburgerMenu';
import WorkIconHelp from '@/components/global_components/work_icons/WorkIconHelp';
import WorkIconHistory from '@/components/global_components/work_icons/WorkIconHistory';
import WorkIconImport from '@/components/global_components/work_icons/WorkIconImport';
import WorkIconInfo from "@/components/global_components/work_icons/WorkIconInfo";
import WorkIconInitialAssessment from "@/components/global_components/work_icons/WorkIconInitialAssessment";
import WorkIconInspection from "@/components/global_components/work_icons/WorkIconInspection";
import WorkIconKey from '@/components/global_components/work_icons/WorkIconKey';
import WorkIconLink from '@/components/global_components/work_icons/WorkIconLink';
import WorkIconLock from '@/components/global_components/work_icons/WorkIconLock';
import WorkIconLocked from '@/components/global_components/work_icons/WorkIconLocked';
import WorkIconLogut from '@/components/global_components/work_icons/WorkIconLogut';
import WorkIconMessageAdd from '@/components/global_components/work_icons/WorkIconMessageAdd';
import WorkIconNext from '@/components/global_components/work_icons/WorkIconNext';
import WorkIconNotification from '@/components/global_components/work_icons/WorkIconNotification';
import WorkIconNotInSync from '@/components/global_components/work_icons/WorkIconNotInSync';
import WorkIconMinus from '@/components/global_components/work_icons/WorkIconMinus';
import WorkIconMobilePhone from "@/components/global_components/work_icons/WorkIconMobilePhone";
import WorkIconMoveProject from '@/components/global_components/work_icons/WorkIconMoveProject';
import WorkIconModuleOverview from '@/components/global_components/work_icons/WorkIconModuleOverview';
import WorkIconMoveable from '@/components/global_components/work_icons/WorkIconMoveable';
import WorkIconOptions from '@/components/global_components/work_icons/WorkIconOptions';
import WorkIconOrdered from '@/components/global_components/work_icons/WorkIconOrdered';
import WorkIconOutsideOffice from '@/components/global_components/work_icons/WorkIconOutsideOffice';
import WorkIconPdf from '@/components/global_components/work_icons/WorkIconPdf';
import WorkIconPlanning from '@/components/global_components/work_icons/WorkIconPlanning';
import WorkIconPrinter from "@/components/global_components/work_icons/WorkIconPrinter";
import WorkIconProposal from '@/components/global_components/work_icons/WorkIconProposal';
import WorkIconProductStorage from '@/components/global_components/work_icons/WorkIconProductStorage';
import WorkIconQrCode from '@/components/global_components/work_icons/WorkIconQrCode';
import WorkIconRadioSelected from '@/components/global_components/work_icons/WorkIconRadioSelected';
import WorkIconRadioUnselected from '@/components/global_components/work_icons/WorkIconRadioUnselected';
import WorkIconRefresh from '@/components/global_components/work_icons/WorkIconRefresh';
import WorkIconRepair from '@/components/global_components/work_icons/WorkIconRepair';
import WorkIconReserved from '@/components/global_components/work_icons/WorkIconReserved';
import WorkIconReservedDemand from '@/components/global_components/work_icons/WorkIconReservedDemand';
import WorkIconRevertArchived from '@/components/global_components/work_icons/WorkIconRevertArchived';
import WorkIconSave from '@/components/global_components/work_icons/WorkIconSave';
import WorkIconSearch from '@/components/global_components/work_icons/WorkIconSearch';
import WorkIconService from '@/components/global_components/work_icons/WorkIconService';
import WorkIconSettings from '@/components/global_components/work_icons/WorkIconSettings';
import WorkIconSmallerThan from '@/components/global_components/work_icons/WorkIconSmallerThan';
import WorkIconOrganizationElement from '@/components/global_components/work_icons/WorkIconOrganizationElement';
import WorkIconRotate from '@/components/global_components/work_icons/WorkIconRotate';
import WorkIconStock from '@/components/global_components/work_icons/WorkIconStock';
import WorkIconSkill from '@/components/global_components/work_icons/WorkIconSkill';
import WorkIconSync from '@/components/global_components/work_icons/WorkIconSync';
import WorkIconTableLayout from '@/components/global_components/work_icons/WorkIconTableLayout';
import WorkIconTag from '@/components/global_components/work_icons/WorkIconTag';
import WorkIconTime from '@/components/global_components/work_icons/WorkIconTime';
import WorkIconUnfold from '@/components/global_components/work_icons/WorkIconUnfold';
import WorkIconUnlink from '@/components/global_components/work_icons/WorkIconUnlink';
import WorkIconUniversalStorage from '@/components/global_components/work_icons/WorkIconUniversalStorage';
import WorkIconUp from '@/components/global_components/work_icons/WorkIconUp';
import WorkIconUpload from '@/components/global_components/work_icons/WorkIconUpload';
import WorkIconUser from '@/components/global_components/work_icons/WorkIconUser';
import WorkIconView from '@/components/global_components/work_icons/WorkIconView';
import WorkIconTextBlock from '@/components/global_components/work_icons/WorkIconTextBlock';
import WorkIconTextBlockAdded from '@/components/global_components/work_icons/WorkIconTextBlockAdded';
import WorkIconWarning from '@/components/global_components/work_icons/WorkIconWarning';
import WorkIconWeb from '@/components/global_components/work_icons/WorkIconWeb';
import WorkIconWidget from '@/components/global_components/work_icons/WorkIconWidget';
import WorkIconCheckboxIndeterminate from "@/components/global_components/work_icons/WorkIconCheckboxIndeterminate";
import WorkIconCheckboxMinus from "@/components/global_components/work_icons/WorkIconCheckboxMinus";
import WorkIconWork from '@/components/global_components/work_icons/WorkIconWork';
import WorkIconBulkExecuteSelection from '@/components/global_components/work_icons/WorkIconBulkExecuteSelection';
import WorkIconNavCollapse from '@/components/global_components/work_icons/WorkIconNavCollapse';
import WorkIconNavWorkingTimeManagment from '@/components/global_components/work_icons/WorkIconNavWorkingTimeManagment';
import WorkIconNavProjectManagment from '@/components/global_components/work_icons/WorkIconNavProjectManagment';
import WorkIconNavProduct from '@/components/global_components/work_icons/WorkIconNavProduct';
import WorkIconNavInvoice from '@/components/global_components/work_icons/WorkIconNavInvoice';
import WorkIconNavNotification from '@/components/global_components/work_icons/WorkIconNavNotification';
import WorkIconNavMonth from '@/components/global_components/work_icons/WorkIconNavMonth';
import WorkIconNavReport from '@/components/global_components/work_icons/WorkIconNavReport';
import WorkIconNavSickNotes from '@/components/global_components/work_icons/WorkIconNavSickNotes';
import WorkIconNavOfficialHolidays from '@/components/global_components/work_icons/WorkIconNavOfficialHolidays';
import WorkIconNavEmployees from '@/components/global_components/work_icons/WorkIconNavEmployees';
import WorkIconNavContacts from '@/components/global_components/work_icons/WorkIconNavContacts';
import WorkIconNavHolidays from '@/components/global_components/work_icons/WorkIconNavHolidays';
import WorkIconNavActivities from '@/components/global_components/work_icons/WorkIconNavActivities';
import WorkIconNavWarehouseManagement from '@/components/global_components/work_icons/WorkIconNavWarehouseManagement';
import WorkIconNavOrdering from '@/components/global_components/work_icons/WorkIconNavOrdering';
import WorkIconNavNavision from '@/components/global_components/work_icons/WorkIconNavNavision.vue';
import WorkIconNavDevices from '@/components/global_components/work_icons/WorkIconNavDevices';
import WorkIconNavProcessSupport from '@/components/global_components/work_icons/WorkIconNavProcessSupport';
import WorkIconNavSystemConfiguration from '@/components/global_components/work_icons/WorkIconNavSystemConfiguration';  
import WorkIconNavSearch from '@/components/global_components/work_icons/WorkIconNavSearch';
import WorkIconNavExpand from '@/components/global_components/work_icons/WorkIconNavExpand';
import WorkIconReset from '@/components/global_components/work_icons/WorkIconReset';
import WorkIconScan from '@/components/global_components/work_icons/WorkIconScan.vue';
import WorkIconWord from '@/components/global_components/work_icons/WorkIconWord';
import WorkIconPriceUpload from '@/components/global_components/work_icons/WorkIconPriceUpload';
import WorkIconPaymentReminder from '@/components/global_components/work_icons/WorkIconPaymentReminder';
import WorkIconSerialNumber from '@/components/global_components/work_icons/WorkIconSerialNumber.vue';
import WorkIconUnreadableSerialNumber from '@/components/global_components/work_icons/WorkIconUnreadableSerialNumber.vue';
import WorkIconDunning from '@/components/global_components/work_icons/WorkIconDunning';

Vue.component('WIconAccessConfig', WorkIconAccessConfig);
Vue.component('WIconAdd', WorkIconAdd);
Vue.component('WIconApplicationReject', WorkIconApplicationReject);
Vue.component('WIconApplicationReopen', WorkIconApplicationReopen);
Vue.component('WIconArchived', WorkIconArchived);
Vue.component('WIconRevertArchived', WorkIconRevertArchived);
Vue.component('WIconApplicationRFeopen', WorkIconApplicationReopen);
Vue.component('WIconArrowDown', WorkIconArrowDown);
Vue.component('WIconAttention', WorkIconAttention);
Vue.component('WIconBack', WorkIconBack);
Vue.component('WIconBulkExecuteSelection', WorkIconBulkExecuteSelection);
Vue.component('WIconBusinessTrip', WorkIconBusinessTrip);
Vue.component('WIconCalculation', WorkIconCalculation);
Vue.component('WIconCalendar', WorkIconCalendar);
Vue.component('WIconCall', WorkIconCall);
Vue.component('WIconCamera', WorkIconCamera);
Vue.component('WIconCar', WorkIconCar);
Vue.component('WIconCheck', WorkIconCheck);
Vue.component('WIconCheckboxIndeterminate', WorkIconCheckboxIndeterminate);
Vue.component('WIconCheckboxMinus', WorkIconCheckboxMinus);
Vue.component('WIconCheckmark', WorkIconCheckmark);
Vue.component('WIconCheckboxSelectAll', WorkIconCheckboxSelectAll);
Vue.component('WIconCheckboxSelect', WorkIconCheckboxSelect);
Vue.component('WIconCheckboxUnselect', WorkIconCheckboxUnselect);
Vue.component('WIconCircle', WorkIconCircle);
Vue.component('WIconClose', WorkIconClose);
Vue.component('WIconConfirmDeviation', WorkIconConfirmDeviation);
Vue.component('WIconContainer', WorkIconContainer);
Vue.component('WIconCollapse', WorkIconCollapse);
Vue.component('WIconColorNoSelection', WorkIconColorNoSelection);
Vue.component('WIconColorSelection', WorkIconColorSelection);
Vue.component('WIconCompany', WorkIconCompany);
Vue.component('WIconCompanyAdd', WorkIconCompanyAdd);
Vue.component('WIconCopyProject', WorkIconCopyProject);
Vue.component('WIconCopyContact', WorkIconCopyContact);
Vue.component('WIconCreateBill', WorkIconCreateBill);
Vue.component('WIconCustomer', WorkIconCustomer);
Vue.component('WIconDashboard', WorkIconDashboard);
Vue.component('WIconDelete', WorkIconDelete);
Vue.component('WIconDemand', WorkIconDemand);
Vue.component('WIconDeputy', WorkIconDeputy);
Vue.component('WIconDocument', WorkIconDocument);
Vue.component('WIconDocumentAdd', WorkIconDocumentAdd);
Vue.component('WIconDocumentPlus', WorkIconDocumentPlus);
Vue.component('WIconDown', WorkIconDown);
Vue.component('WIconDownload', WorkIconDownload);
Vue.component('WIconDownloadCsv', WorkIconDownloadCsv);
Vue.component('WIconDownloadExcel', WorkIconDownloadExcel);
Vue.component('WIconDownloadZip', WorkIconDownloadZip);
Vue.component('WIconEdit', WorkIconEdit);
Vue.component('WIconEditModeOff', WorkIconEditModeOff);
Vue.component('WIconEditModeOffAlt', WorkIconEditModeOffAlt);
Vue.component('WIconEditModeOn', WorkIconEditModeOn);
Vue.component('WIconEditView', WorkIconEditView);
Vue.component('WIconElectricMagnifier', WorkIconElectricMagnifier);
Vue.component('WIconEmail', WorkIconEmail);
Vue.component('WIconEquals', WorkIconEquals);
Vue.component('WIconExport', WorkIconExport);
Vue.component('WIconExportMessage', WorkIconExportMessage);
Vue.component('WIconFavorite', WorkIconFavorite);
Vue.component('WIconFavoriteFilled', WorkIconFavoriteFilled);
Vue.component('WIconFilter', WorkIconFilter);
Vue.component('WIconFilterAdd', WorkIconFilterAdd);
Vue.component('WIconFilterSelect', WorkIconFilterSelect);
Vue.component('WIconGlobalSearch', WorkIconGlobalSearch);
Vue.component('WIconGreaterThan', WorkIconGreaterThan);
Vue.component('WIconHamburgerMenu', WorkIconHamburgerMenu);
Vue.component('WIconHelp', WorkIconHelp);
Vue.component('WIconHistory', WorkIconHistory);
Vue.component('WIconImport', WorkIconImport);
Vue.component('WIconInfo', WorkIconInfo);
Vue.component('WIconInitialAssessment', WorkIconInitialAssessment);
Vue.component('WIconInspection', WorkIconInspection);
Vue.component('WIconKey', WorkIconKey);
Vue.component('WIconLink', WorkIconLink);
Vue.component('WIconLock', WorkIconLock);
Vue.component('WIconLocked', WorkIconLocked);
Vue.component('WIconLogout', WorkIconLogut);
Vue.component('WIconMessageAdd', WorkIconMessageAdd);
Vue.component('WIconNavActivities', WorkIconNavActivities);
Vue.component('WIconNavCollapse', WorkIconNavCollapse);
Vue.component('WIconNavContacts', WorkIconNavContacts);
Vue.component('WIconNavDevices', WorkIconNavDevices);
Vue.component('WIconNavEmployees', WorkIconNavEmployees);
Vue.component('WIconNavExpand', WorkIconNavExpand); 
Vue.component('WIconNavHolidays', WorkIconNavHolidays);
Vue.component('WIconNavInvoice', WorkIconNavInvoice);
Vue.component('WIconNavMonth', WorkIconNavMonth);
Vue.component('WIconNavNotification', WorkIconNavNotification);
Vue.component('WIconNavOfficialHolidays', WorkIconNavOfficialHolidays);
Vue.component('WIconNavOrdering', WorkIconNavOrdering);
Vue.component('WIconNavNavision', WorkIconNavNavision);
Vue.component('WIconNavProcessSupport', WorkIconNavProcessSupport);
Vue.component('WIconNavProduct', WorkIconNavProduct);
Vue.component('WIconNavProjectManagment', WorkIconNavProjectManagment);
Vue.component('WIconNavReport', WorkIconNavReport);
Vue.component('WIconNavSearch', WorkIconNavSearch);
Vue.component('WIconNavSickNotes', WorkIconNavSickNotes);
Vue.component('WIconNavSystemConfiguration', WorkIconNavSystemConfiguration);
Vue.component('WIconNavWarehouseManagement', WorkIconNavWarehouseManagement);
Vue.component('WIconNavWorkingTimeManagment', WorkIconNavWorkingTimeManagment);
Vue.component('WIconNext', WorkIconNext);
Vue.component('WIconNotification', WorkIconNotification);
Vue.component('WIconNotInSync', WorkIconNotInSync);
Vue.component('WIconMinus', WorkIconMinus);
Vue.component('WIconMobilePhone', WorkIconMobilePhone);
Vue.component('WIconModuleOverview', WorkIconModuleOverview);
Vue.component('WIconMoveProject', WorkIconMoveProject);
Vue.component('WIconMoveable', WorkIconMoveable);
Vue.component('WIconPaymentReminder', WorkIconPaymentReminder);
Vue.component('WIconPdf', WorkIconPdf);
Vue.component('WIconPlanning', WorkIconPlanning);
Vue.component('WIconPriceUpload', WorkIconPriceUpload);
Vue.component('WIconPrinter', WorkIconPrinter);
Vue.component('WIconProductStorage', WorkIconProductStorage);
Vue.component('WIconProposal', WorkIconProposal);
Vue.component('WIconQrCode', WorkIconQrCode);
Vue.component('WIconOptions', WorkIconOptions);
Vue.component('WIconOrdered', WorkIconOrdered);
Vue.component('WIconOrganizationElement', WorkIconOrganizationElement);
Vue.component('WIconOutsideOffice', WorkIconOutsideOffice);
Vue.component('WIconRadioSelected', WorkIconRadioSelected);
Vue.component('WIconRadioUnselected', WorkIconRadioUnselected);
Vue.component('WIconRefresh', WorkIconRefresh);
Vue.component('WIconRepair', WorkIconRepair);
Vue.component('WIconReserved', WorkIconReserved);
Vue.component('WIconReservedDemand', WorkIconReservedDemand);
Vue.component('WIconReset', WorkIconReset);
Vue.component('WIconRotate', WorkIconRotate);
Vue.component('WIconSave', WorkIconSave);
Vue.component('WIconScan', WorkIconScan);
Vue.component('WIconSearch', WorkIconSearch);
Vue.component('WIconSerialNumber', WorkIconSerialNumber);
Vue.component('WIconService', WorkIconService);
Vue.component('WIconSettings', WorkIconSettings);
Vue.component('WIconSkill', WorkIconSkill);
Vue.component('WIconSmallerThan', WorkIconSmallerThan);
Vue.component('WIconStock', WorkIconStock);
Vue.component('WIconSync', WorkIconSync);
Vue.component('WIconTableLayout', WorkIconTableLayout);
Vue.component('WIconTag', WorkIconTag);
Vue.component('WIconTextBlock', WorkIconTextBlock);
Vue.component('WIconTextBlockAdded', WorkIconTextBlockAdded);
Vue.component('WIconTime', WorkIconTime);
Vue.component('WIconUnfold', WorkIconUnfold);
Vue.component('WIconUnlink', WorkIconUnlink);
Vue.component('WIconUniversalStorage', WorkIconUniversalStorage);
Vue.component('WIconUnreadableSerialNumber', WorkIconUnreadableSerialNumber);
Vue.component('WIconUp', WorkIconUp);
Vue.component('WIconUpload', WorkIconUpload);
Vue.component('WIconUser', WorkIconUser);
Vue.component('WIconView', WorkIconView);
Vue.component('WIconWarning', WorkIconWarning);
Vue.component('WIconWeb', WorkIconWeb);
Vue.component('WIconWidget', WorkIconWidget);
Vue.component('WIconWork', WorkIconWork);
Vue.component('WIconWord', WorkIconWord);
Vue.component('WIconDunning', WorkIconDunning);
